// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-fix-tab":"FixTab_cost-saving-fix-tab__3_HvM"};